<template>
    <section id="meublePlano" class="flexContainer fd-c full">
        <section id="meublePlanoWrapper">
            <h2 class="ff-medium uppercase center listTitle">{{ $t("meublePlano.title") }}</h2>
            <form class="full">
                <div class="plano flexContainer ai-fs fd-r ai-s">
                    <div id="spinnerLoader" class="abs flexContainer" v-if="loading === true">
                        <Spinner :animation-duration="2500" :size="60" :color="'#41b4e8'" class="loader"></Spinner>
                    </div>
                    <div class="formBuilder scrollY">
                        <form enctype="multipart/form-data" class="form_campaing" action="">
                            <div class="">
                                <div class="form-group row">
                                    <label for="example-text-input" class="col-4 col-form-label">{{ $t("meublePlano.name") }}</label>
                                    <div class="col-8"><input class="full" v-model="name" /></div>
                                </div>
                                <br />
                                <h3 class="ff-medium uppercase label">{{ $t("meublePlano.externalSize") }}</h3>
                                <div class="form-group row">
                                    <label for="example-text-input" class="col-4 col-form-label">{{ $t("meublePlano.width") }}</label>
                                    <div class="col-8"><input class="full" type="number" placeholder="Width" v-model="largeurExt" min="0" /></div>
                                </div>
                                <br />
                                <div class="form-group row">
                                    <label for="example-text-input" class="col-4 col-form-label">{{ $t("meublePlano.height") }}</label>
                                    <div class="col-8"><input class="full" type="number" placeholder="Height" v-model="hauteurExt" min="0" /></div>
                                </div>
                                <br />
                                <h3 class="ff-medium uppercase label">{{ $t("meublePlano.internalSize") }}</h3>
                                <div class="form-group row">
                                    <label for="example-text-input" class="col-4 col-form-label">{{ $t("meublePlano.header") }}</label>
                                    <div class="col-8">
                                        <input class="full" type="number" placeholder="Padding top" v-model="largeurInt" min="0" />
                                    </div>
                                </div>
                                <br />
                                <div class="form-group row">
                                    <label for="example-text-input" class="col-4 col-form-label">{{ $t("meublePlano.footer") }}</label>
                                    <div class="col-8">
                                        <input class="full" type="number" placeholder="Padding bottom" v-model="hauteurInt" min="0" />
                                    </div>
                                </div>
                                <br />
                                <h3 class="ff-medium uppercase label">{{ $t("meublePlano.planoModule") }}</h3>
                                <div class="form-group row">
                                    <label for="example-text-input" class="col-4 col-form-label">{{ $t("meublePlano.width") }}</label>
                                    <div class="col-8">
                                        <input class="full" type="number" placeholder="Width cadre" v-model="widthCadre" min="0" />
                                    </div>
                                </div>
                                <br />
                                <div class="form-group row">
                                    <label for="example-text-input" class="col-4 col-form-label">{{ $t("meublePlano.height") }}</label>
                                    <div class="col-8">
                                        <input class="full" type="number" placeholder="Height cadre" v-model="heightCadre" min="0" />
                                    </div>
                                </div>
                                <br />
                                <h3 class="ff-medium uppercase label">Displayer type</h3>
                                <div class="form-group row">
                                    <div class="col-12">
                                        <select id="selectSeg" class="full" v-model="displayType">
                                            <option :value="null">Select display</option>
                                            <option v-for="(type, index) in getDisplayType" :key="index" :value="type.id">{{ type.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <br />
                                <h3 class="ff-medium uppercase label">Stand Design List</h3>
                                <div class="form-group row">
                                    <div class="col-12">
                                        <select id="selectSeg" class="full" v-model="standDesign">
                                            <option :value="null">Select stand design</option>
                                            <option v-for="(n, index) in standDesignList" :key="index" :value="n.id"> {{ n.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <br />
                                <h3 class="ff-medium uppercase label">{{ $t("meublePlano.segmentation") }}</h3>
                                <div class="form-group row">
                                    <div class="col-12">
                                        <select id="selectSeg" class="full" v-model="segmentation">
                                            <option :value="null">Select taille</option>
                                            <option v-for="(option, index) in segList" :key="index" :value="option">{{ option }}</option>
                                        </select>
                                    </div>
                                </div>
                                <br />
                                <h3 class="ff-medium label uppercase">{{ $t("meublePlano.pitchH") }}</h3>
                                <div class="form-group row">
                                    <label for="example-text-input" class="col-4 col-form-label">{{ $t("meublePlano.pitchH") }}</label>
                                    <div class="col-8">
                                        <input class="full" type="number" placeholder="Width pitch" v-model="pitchHWidth" min="0" />
                                    </div>
                                </div>
                                <br />
                                <div class="form-group row">
                                    <label for="example-text-input" class="col-4 col-form-label">{{ $t("meublePlano.pitchR") }}</label>
                                    <div class="col-8">
                                        <input class="full" type="number" placeholder="Number of repetitions" v-model="pitchRepH" min="0" />
                                    </div>
                                </div>
                                <br />
                                <h3 class="ff-medium label uppercase">{{ $t("meublePlano.pitchV") }}</h3>
                                <div class="form-group row">
                                    <label for="example-text-input" class="col-4 col-form-label">{{ $t("meublePlano.pitchV") }}</label>
                                    <div class="col-8">
                                        <input class="full" type="number" placeholder="Width pitch" v-model="pitchVWidth" min="0" />
                                    </div>
                                </div>
                                <br />
                                <div class="form-group row">
                                    <label for="example-text-input" class="col-4 col-form-label">{{ $t("meublePlano.pitchR") }}</label>
                                    <div class="col-8">
                                        <input class="full" type="number" placeholder="Number of repetitions" v-model="pitchRepV" min="0" />
                                    </div>
                                </div>
                                <br />
                                <h3 class="ff-medium label uppercase">{{ $t("meublePlano.setBloc") }}</h3>
                                <div class="form-group row">
                                    <label for="example-text-input" class="col-4 col-form-label">{{ $t("meublePlano.blocWidth") }}</label>
                                    <div class="col-8">
                                        <input class="full" type="number" placeholder="Width pitch" v-model="blockWidth" min="0" />
                                    </div>
                                </div>
                                <br />
                                <div class="form-group row">
                                    <label for="example-text-input" class="col-4 col-form-label">{{ $t("meublePlano.numberOfBlocs") }}</label>
                                    <div class="col-8">
                                        <input class="full" type="number" placeholder="Number of repetitions" v-model="blockRep" min="0" />
                                    </div>
                                </div>
                                <br />
                            </div>
                            <button type="button" class="btn pointer fright" @click="saveMeuble();">{{ $t("meublePlano.save") }}</button>
                        </form>
                    </div>
                    <div class="planoMeuble full">
                        <div id="planoPreview">
                            <div
                                class="rel cadreExt flexContainer"
                                :style="{
                                    width: getSizeExt.width + 'px',
                                    height: getSizeExt.height + 'px',
                                    zIndex: 1,
                                    border: '2px solid black',
                                    backgroundColor: '#ccc'
                                }"
                                v-if="getSizeExt.height !== 0 && getSizeExt.height !== 0"
                            >
                                <div class="flexContainer full rel">
                                    <div
                                        id="segmentation"
                                        class="abs"
                                        :style="{ width: getSizeInt.width + 'px', height: getSeg.height + 'px', top: getMargin.top + 'px' }"
                                    ></div>
                                </div>
                                <div
                                    class="abs cadreTest flexContainer"
                                    :style="{
                                        width: '100%',
                                        top: getMargin.top + 'px',
                                        bottom: getMargin.bottom + 'px',
                                        zIndex: 2,
                                        borderTop: '1px solid black',
                                        borderBottom: '1px solid black'
                                    }"
                                    v-if="getMargin.top !== 0"
                                >
                                    <div class="cadre flexContainer" :style="{ width: getSizeExt.width + 'px' }">
                                        <div class="margAuto">
                                            <div class="flexContainer">
                                                <div
                                                    class="cadreInt"
                                                    :style="{
                                                        width: getSizeInt.width + 'px',
                                                        height: getSizeInt.height + 'px',
                                                        zIndex: 1,
                                                        border: '1px solid black',
                                                        backgroundColor: 'white'
                                                    }"
                                                    v-if="
                                                        getSizeInt.width !== 0 &&
                                                            getSizeInt.height !== 0 &&
                                                            getSizeInt.height <= getSizeExt.height - getMargin.top - getMargin.bottom
                                                    "
                                                >
                                                    <div class="abs">
                                                        <div
                                                            class="pitchH"
                                                            v-for="(nbH, index) in parseInt(pitchRepH)"
                                                            :key="index"
                                                            :style="{
                                                                width: getPicth.x + 'px',
                                                                height: getSizeInt.height + 'px',
                                                                zIndex: 2,
                                                                borderRight: '1px solid black',
                                                                'border-right-style': 'dotted'
                                                            }"
                                                            v-if="getPicth.x * pitchRepH <= getSizeInt.width"
                                                        ></div>
                                                    </div>
                                                    <div class="abs toto" :style="{ width: getSizeInt.width + 'px' }">
                                                        <div
                                                            class="pitchV"
                                                            v-for="(nbV, index) in parseInt(pitchRepV)"
                                                            :key="index"
                                                            :style="{
                                                                width: getSizeInt.width + 'px',
                                                                height: getPicth.y + 'px',
                                                                zIndex: 2,
                                                                borderBottom: '1px solid black',
                                                                'border-bottom-style': 'dotted'
                                                            }"
                                                            v-if="getPicth.y * pitchRepV <= getSizeInt.height"
                                                        ></div>
                                                    </div>
                                                    <div class="abs">
                                                        <div
                                                            class="pitchV"
                                                            v-for="nbR in parseInt(blockRep)"
                                                            :key="nbR"
                                                            :style="{
                                                                width: getPicthBlock.width + 'px',
                                                                height: getSizeInt.height + 'px',
                                                                zIndex: 2,
                                                                borderRight: '2px solid red'
                                                            }"
                                                            v-if="getPicthBlock.width * blockRep <= getSizeInt.width"
                                                        ></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h2 v-if="getPicth.x * pitchRepH <= getSizeInt.width" class="fright">
                            &nbsp;{{ $t("meublePlano.remainingSpaceH") }}: {{ getSizeInt.width - getPicth.x * pitchRepH }}
                        </h2>
                        <h2 v-if="getPicth.y * pitchRepV <= getSizeInt.height" class="fright">
                            {{ $t("meublePlano.remainingSpaceV") }}: {{ getSizeInt.height - getPicth.y * pitchRepV }} /
                        </h2>
                    </div>
                </div>
            </form>
        </section>
    </section>
</template>

<script>
import httpService from "../service";
import { mapGetters } from "vuex";
import Spinner from "vue-simple-spinner";

export default {
    data() {
        return {
            name: "",
            blockName: "",
            segmentation: null,
            displayType: null,
            standDesign: null,
            blockWidth: 0,
            blockRep: 0,
            largeurExt: 0,
            largeurInt: 0,
            hauteurExt: 0,
            hauteurInt: 0,
            widthCadre: 0,
            heightCadre: 0,
            pitchHWidth: 0,
            pitchRepH: 0,
            pitchVWidth: 0,
            pitchRepV: 0,
            display: {},
            range: 1,
            segList: ["45", "100", "70"],
            ratio: 0,
            loading: false,
            standDesignList: {}
        };
    },
    components: {
        Spinner
    },
    computed: {
        getSizeExt() {
            let heightChild = parseInt(this.hauteurExt, 10);
            let widthChild = parseInt(this.largeurExt, 10);
            if (this.ratio === 0) return { width: 0, height: 0 };
            return { width: widthChild * this.ratio, height: heightChild * this.ratio };
        },
        getSizeInt() {
            let heightChild = parseInt(this.heightCadre, 10);
            let widthChild = parseInt(this.widthCadre, 10);
            if (this.ratio === 0) return { width: 0, height: 0 };
            return { width: widthChild * this.ratio, height: heightChild * this.ratio };
        },
        getMargin() {
            let bottomChild = parseInt(this.hauteurInt, 10);
            let topChild = parseInt(this.largeurInt, 10);
            if (this.ratio === 0) return { top: 0, bottom: 0 };
            return { top: topChild * this.ratio, bottom: bottomChild * this.ratio };
        },
        getPicth() {
            let heightChild = parseInt(this.pitchVWidth, 10);
            let widthChild = parseInt(this.pitchHWidth, 10);
            if (this.ratio === 0) return { x: 0, y: 0 };
            return { x: widthChild * this.ratio, y: heightChild * this.ratio };
        },
        getPicthBlock() {
            let widthChild = parseInt(this.blockWidth, 10);
            if (this.ratio === 0) return { width: 0 };
            return { width: widthChild * this.ratio };
        },
        getSeg() {
            let heightChild = parseInt(this.segmentation, 10);
            if (this.ratio === 0) return { height: 0 };
            return { height: heightChild * this.ratio };
        },
        ...mapGetters({
            getDisplayType: "displays/getDisplayType"
        })
    },
    watch: {
        largeurExt(value) {
            this.calculRatio(value);
        },
        hauteurExt(value) {
            this.calculRatio(value);
        }
    },
    methods: {
        calculRatio(value) {
            let heightChild = parseInt(this.hauteurExt, 10);
            let widthChild = parseInt(this.largeurExt, 10);
            let heightParent = this.getSizePlano().height;
            let widthParent = this.getSizePlano().width;
            let ratioH = heightParent / heightChild;
            let ratioW = widthParent / widthChild;
            let ratio = 0;
            if (widthChild === heightChild) {
                if (ratioH < ratioW) {
                    ratio = ratioH;
                } else {
                    ratio = ratioW;
                }
            } else if (widthChild < heightChild) {
                ratio = ratioH;
            } else {
                ratio = ratioW;
            }
            this.ratio = ratio;
        },
        getSizePlano() {
            let planoPreview = document.getElementById("planoPreview");
            if (!planoPreview) {
                return { width: 0, height: 0 };
            }
            let prevHeight = planoPreview.clientHeight;
            let prevWidth = planoPreview.clientWidth;
            return { width: prevWidth, height: prevHeight };
        },
        async saveMeuble() {
            this.display = {
                name: this.name,
                heightExternal: this.hauteurExt,
                widthExternal: this.largeurExt,
                heightInternal: this.heightCadre,
                widthInternal: this.widthCadre,
                segmentation_bar_width: this.widthCadre,
                segmentation_bar_height: this.segmentation,
                base: this.hauteurInt,
                front: this.largeurInt,
                isRegularVertical: true,
                isRegularHorizontal: true,
                displayerType: {
                    id: this.displayType
                },
                systemType: {
                    id: 1
                },
                standDesign: {
                    id: this.standDesign
                },
                steps: [
                    {
                        length: this.pitchVWidth,
                        repeat: this.pitchRepV,
                        active: true,
                        orientation: "vertical"
                    },
                    {
                        length: this.pitchHWidth,
                        repeat: this.pitchRepH,
                        active: true,
                        orientation: "horizontal"
                    }
                ],
                blocks: [
                    {
                        length: this.blockWidth,
                        repeat: this.blockRep,
                        orderBy: 1
                    }
                ]
            };

            if (this.display.standDesign.id === null) {
                this.dialogError(this.$t("meublePlano.errorSetStandDesign"));
                return;
            }
            try {
                const response = await httpService.post("/admin/displayer/new", JSON.stringify(this.display));
                if (response.code) throw new Error(response.message);
                this.$swal({
                    text: "ENREGISTREE AVEC SUCCES",
                    type: "success",
                    showCancelButton: false,
                    confirmButtonText: "OK",
                    confirmButtonColor: "#41b4e8",
                    closeOnConfirm: true,
                    closeOnCancel: true
                }).then(result => {
                    this.loading = false;
                    location.reload();
                });
            } catch (e) {
                this.dialogError(e);
            } finally {
                this.loading = false;
            }
        }
    },
    mounted() {},
    created() {
        this.$store.dispatch("displays/getDisplayType").then(() => {});
        httpService.get("/admin/standDesigns/list?type=stand").then(response => {
            this.standDesignList = response.data;
        });
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes.scss";

#spinnerLoader {
    left: 0;
    top: 50%;
    width: 100%;
    .loader {
        margin: auto;
    }
}

#meublePlano {
    margin-top: 10px;
    @extend %primary-bloc;
    @extend %primary-text;
    border-radius: 3px;
    #meublePlanoWrapper {
        padding: 30px 30px 30px 30px;
        .plano {
            padding-top: 30px;
            .formBuilder {
                max-width: 430px;
                margin-right: 30px;
                height: calc(100vh - 300px);
                padding-right: 15px;
                .formGroup {
                    width: inherit;
                    input {
                        height: 30px;
                        font-size: 14px;
                        padding-left: 10px;
                        margin-bottom: 15px;
                    }
                    .label {
                        font-size: 12px;
                        font-family: "Roboto", sans-serif;
                        padding-bottom: 5px;
                    }
                    h3 {
                        color: #666;
                    }
                    #selectSeg {
                        height: 30px;
                        margin-bottom: 20px;
                        font-size: 1.4rem;
                    }
                }
            }
        }
    }
    .planoMeuble {
        #planoPreview {
            height: 100%;
        }
        .cadreExt,
        .cadreTest {
            #segmentation {
                background: #343434;
                margin: auto;
                left: 0;
                right: 0;
                padding: 0 15px;
                .segName {
                    color: #fff;
                    height: 25px;
                    line-height: 25px;
                }
            }
            .cadre {
                .cadreInt {
                    margin: auto;
                    overflow: hidden;
                    .pitchH {
                        display: inline-block;
                    }
                    .pitchV {
                        display: inline-block;
                    }
                }
            }
        }
    }
}

.formGroup {
    width: 140%;
}

.divDroite {
    margin-left: 10px;
}

.blockName {
    width: 50%;
}
</style>



// WEBPACK FOOTER //
// ParamMeuble.vue?0a7ffe5b